module.exports = __webpack_public_path__ + "static/media/01-1920x1080-px .jpg";